var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVollbildEin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.4855586,24.3661221 L26.4855586,20.9811221 L27.9815586,20.9811221 L27.9815586,26.9501221 L21.9815586,26.9501221 L22.0665586,25.4761221 L25.4475586,25.4761221 L21.8469102,22.2854482 L23.2169102,20.9154482 L26.4855586,24.3661221 Z M14.5112676,24.3661221 L14.5112676,20.9811221 L13.0152676,20.9811221 L13.0152676,26.9501221 L19.0152676,26.9501221 L18.9302676,25.4761221 L15.5492676,25.4761221 L19.149916,22.2854482 L17.779916,20.9154482 L14.5112676,24.3661221 Z M26.4855586,14.5639316 L26.4855586,17.9489316 L27.9815586,17.9489316 L27.9815586,11.9799316 L21.9815586,11.9799316 L22.0665586,13.4539316 L25.4475586,13.4539316 L21.8469102,16.6446055 L23.2169102,18.0146055 L26.4855586,14.5639316 Z M14.5112676,14.5639316 L14.5112676,17.9489316 L13.0152676,17.9489316 L13.0152676,11.9799316 L19.0152676,11.9799316 L18.9302676,13.4539316 L15.5492676,13.4539316 L19.149916,16.6446055 L17.779916,18.0146055 L14.5112676,14.5639316 Z",
    id: ".._.._src_svg_Icn_40px_Vollbild-Ein__path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Vollbild-Ein__Icn/40px/Vollbild-Ein",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Vollbild-Ein__Color/20px/Platzhalter-Transparent",
    transform: "translate(10 10)",
    fillRule: "nonzero",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Vollbild-Ein__Rectangle",
    d: "M0 0H20V20H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: ".._.._src_svg_Icn_40px_Vollbild-Ein__mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#.._.._src_svg_Icn_40px_Vollbild-Ein__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: ".._.._src_svg_Icn_40px_Vollbild-Ein__Shape",
    xlinkHref: "#.._.._src_svg_Icn_40px_Vollbild-Ein__path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVollbildEin);
export default __webpack_public_path__ + "static/media/Vollbild-Ein.f78d411e1f2bb5cb515fc13885fa8e34.svg";
export { ForwardRef as ReactComponent };